import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { EmrIntegrationDtoSchema } from '../contracts';

const UpdateEmrCredentialsRequestDtoSchema = z.object({
  credentials: z.object({ username: z.string(), password: z.string() }),
});

const UpdateEmrCredentialsResponseDtoSchema = EmrIntegrationDtoSchema;

export type UpdateEmrCredentialsRequestDto = z.infer<
  typeof UpdateEmrCredentialsRequestDtoSchema
>;
export type UpdateEmrCredentialsResponseDto = z.infer<
  typeof UpdateEmrCredentialsResponseDtoSchema
>;

export const updateEmrCredentials = (
  dto: UpdateEmrCredentialsRequestDto,
  config?: AxiosRequestConfig<UpdateEmrCredentialsRequestDto>
) => {
  const data = UpdateEmrCredentialsRequestDtoSchema.parse(dto);

  const requestDtoConfig = { authType: 'BASIC' };

  return api
    .post(
      '/integrations/update-credentials',
      { ...data, ...requestDtoConfig },
      config
    )
    .then(responseContract(UpdateEmrCredentialsResponseDtoSchema));
};
